module.exports = __webpack_public_path__ + "img/trash.af4bc6c3.svg";